import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-cloud-modernization-and-migration',
  templateUrl: './cloud-modernization-and-migration.component.html',
  styleUrls: ['./cloud-modernization-and-migration.component.css']
})
export class CloudModernizationAndMigrationComponent { 
  
  isBrowser:boolean=false;

  constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2, private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
 {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/ouropinion-casestudy/"
  },
  "headline": "Opinion polling made seamless",
  "description": "Learn how we built a global website, with minimal downtime, with future cloud advances incorporated into client's IT infrastructure.",
  "image": "https://mitresource.com/wp-content/themes/magantiWeb/assets/images/banners/ouropinion_mobilebannar.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/wp-content/themes/magantiWeb/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2023-06-15"
}`;
    
    this._renderer2.appendChild(this._document.head, script);
      this.setTitleAndMetaTags();
      this.seoService.createLinkForCanonicalURL();
    if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
}
   
      this.setTitleAndMetaTags();
  }
  baseUrl = Constants.baseUrl;

 

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Cloud Hosting & Cloud Computing Services | Maganti IT');
    this.metaService.addTags([
      { name: 'description', content: 'Bring your business into the cloud with customized cloud hosting services and cloud computing solutions including private, public and hybrid cloud services.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Cloud Hosting & Cloud Computing Services | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/artificial-Intelligence/' },
      { property: 'og:image', content: 'https://mitresource.com//assets/images/banners/mit-favicon.png' },
      { property: 'og:description', content: 'Bring your business into the cloud with customized cloud hosting services and cloud computing solutions including private, public and hybrid cloud services.' },
    ]);
  }
}
